module.exports = __webpack_public_path__ + "img/Assistant_Branding.98ab259e.svg";